import { useEffect } from 'react';
import { render } from 'react-dom';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import './style.scss';
import Portfolio from './Portfolio';
import camelCase from './utils/camelCase';

document.addEventListener('DOMContentLoaded', () => {
	const allPortfolio = document.querySelectorAll('.wp-block-pfb-portfolio');
	allPortfolio.forEach(portfolio => {
		const attributes = JSON.parse(portfolio.dataset.attributes);
		const { cId } = attributes;

		render(<Portfolio attributes={attributes} clientId={cId}>
			<Gallery attributes={attributes} clientId={cId} />
		</Portfolio>, portfolio);

		portfolio?.removeAttribute('data-attributes');
	});
});

const Gallery = ({ attributes, clientId }) => {
	const { portfolios, itemHoverEffect, isLink, titleStyle } = attributes;

	useEffect(() => {
		Fancybox.bind(`[data-fancybox='pfbGallery-${clientId}']`, {
			mainClass: `pfbFancyBox pfbFancyBox-${clientId}`,
			Toolbar: {
				display: {
					left: [],
					middle: [],
					right: ['slideshow', 'close'],
				}
			},
			Thumbs: false,
			contentClick: 'toggleZoom', // 'toggleZoom' | 'toggleCover' | 'toggleMax' | 'zoomToFit' | 'zoomToMax' | 'iterateZoom' | false | 'close' | 'next' | 'prev'
		});
	}, []);

	const fancyCapBodySl = `.pfbFancyBox-${clientId} .fancybox__caption`;

	return <div id={`gallery-${clientId}`} className='gallery isotopeNotInit'>
		<style dangerouslySetInnerHTML={{
			__html: `
			${fancyCapBodySl} a{
				display: ${isLink ? 'inline-flex' : 'none'};
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20px' height='20px' viewBox='0 0 24 24' fill='%23ffffff'%3E%3Cpath d='M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L17.585 5H13V3h8z' /%3E%3C/svg%3E");
			}
			${fancyCapBodySl} a:hover{
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20px' height='20px' viewBox='0 0 24 24' fill='%23a78bff'%3E%3Cpath d='M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L17.585 5H13V3h8z' /%3E%3C/svg%3E");
			}
			`.replace(/\s+/g, ' ')
		}} />

		{portfolios?.map((item, index) => {
			const { image, title, link, cats } = item;

			return <a
				key={index}
				className={`galleryItem ${cats?.map(cat => camelCase(cat)).join(' ')}`}
				data-fancybox={`pfbGallery-${clientId}`}
				href={image?.url}
				data-caption={`${title} <a href='${link}'></a>`}
			>
				<figure className={`galleryFigure ${itemHoverEffect}`}>
					<img src={image?.url} alt={image?.alt || image?.title} />
					{<figcaption className={titleStyle}><p>{title}</p></figcaption>}
				</figure>
			</a>;
		})}
	</div>
}